import Vue from "vue"

let vm = {
  data: () => {
    return {
      min: 0,
      max: 100
    }
  },
  props: {
    minProp:Number,
    maxProp:Number,
    decimable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changePrevMin() {
      if(Number(this.min) >= Number(this.max))  this.min = this.max
    },
    changeNextMin() {
      if(Number(this.min) <= this.minProp)  this.min = this.minProp
    },
    changePrevMax() {
      if(Number(this.max) >= this.maxProp)  this.max = this.maxProp
    },
    changeNextMax() {
      if(Number(this.min) >= Number(this.max))  this.max = this.min 
    },
    minBlur() {
      if (!this.decimable) {
        this.min = Math.floor(this.min)
      }
      if(!this.min) {
        this.min = this.minProp
      }
      if (Number(this.min) < this.minProp) {
        this.min = this.minProp
        this.$message.info('不能小于最小值');
      }
      if (Number(this.min) > Number(this.max))  {
        this.min = this.minProp
        this.$message.info('不能大于最大值');
      }
    },
    maxBlur() {
      if (!this.decimable) {
        this.max = Math.ceil(this.max)
      }
      if(!this.max) {
        this.max = this.maxProp
      }
      if (Number(this.max) > this.maxProp) {
        this.max = this.maxProp
        this.$message.info('不能大于最大值');
      }
      if (Number(this.max) < Number(this.min))  {
        this.max = this.maxProp
        this.$message.info('不能小于最小值');
      }
    },
    clear() {
      this.min = this.minProp
      this.max = this.maxProp
    }
  },
  watch: {
    min(value) {
      this.$emit('changeMin', this.min)
    },
    max(value) {
      this.$emit('changeMax', this.max)
    }
  },
  created() {
    this.min = this.minProp
    this.max = this.maxProp
  }
}
// Vue.component('revenue-prop-filter', vm)
export default vm


// WEBPACK FOOTER //
// ./src/common/js/RevenuePropFilter.js